import { render, staticRenderFns } from "./AddPointProgram.vue?vue&type=template&id=556a96e3"
import script from "./AddPointProgram.vue?vue&type=script&lang=js"
export * from "./AddPointProgram.vue?vue&type=script&lang=js"
import style0 from "./AddPointProgram.vue?vue&type=style&index=0&id=556a96e3&prod&lang=css"
import style1 from "./AddPointProgram.vue?vue&type=style&index=1&id=556a96e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports